const STATE_PENDING = 0;
const STATE_FINALISHED = 1;
const STATE_CANCELED = 2;
const STATE_PARTIALLY = 3;
const STATE_APPROVED = 4; // No se usa en backend - mantener por compatibilidad
const STATE_REJECTED = 5;
const STATE_PENDING_APPROVAL = 6; // Nuevo: Pendiente de Aprobación

const STATE_PENDING_NAME = "Pendiente";
const STATE_FINALISHED_NAME = "Finalizada";
const STATE_CANCELED_NAME = "Cancelada";
const STATE_PARTIALLY_NAME = "Factura parcialmente";
const STATE_APPROVED_NAME = "Aprobada";
const STATE_REJECTED_NAME = "Rechazada";
const STATE_PENDING_APPROVAL_NAME = "Pendiente de Aprobación";


export const ordersState= {
  STATE_PENDING: STATE_PENDING,
  STATE_FINALISHED: STATE_FINALISHED,
  STATE_CANCELED: STATE_CANCELED,
  STATE_PARTIALLY: STATE_PARTIALLY,
  STATE_APPROVED: STATE_APPROVED,
  STATE_REJECTED: STATE_REJECTED,
  STATE_PENDING_APPROVAL: STATE_PENDING_APPROVAL,
  STATE_PENDING_NAME: STATE_PENDING_NAME,
  STATE_FINALISHED_NAME: STATE_FINALISHED_NAME,
  STATE_CANCELED_NAME: STATE_CANCELED_NAME,
  STATE_PARTIALLY_NAME: STATE_PARTIALLY_NAME,
  STATE_APPROVED_NAME: STATE_APPROVED_NAME,
  STATE_REJECTED_NAME: STATE_REJECTED_NAME,
  STATE_PENDING_APPROVAL_NAME: STATE_PENDING_APPROVAL_NAME,
};